// Central route table. Detail routes are functions so callers build URLs without string literals.
export const ROUTES = {
  DASHBOARD: '/',
  CATALOG: '/catalog',
  COSTS: '/costs',
  LIBRARY: '/library',
  DOCUMENTS: '/documents',
  DOCUMENT_DETAIL: (id = ':id') => `/documents/${id}`,
  TOPIC_DETAIL: (id = ':id') => `/topics/${id}`,
  PARAGRAPH_DETAIL: (id = ':id') => `/paragraphs/${id}`,
  SYSTEM: '/system',
  SETTINGS: '/settings',
};

export default ROUTES;
